import Axios from 'axios';
import Qs from 'qs';

export default {

  // 车场配置分页列表
  listPage(
    status,
    community_id,
    page,
    per_page
  ) {
    return Axios.get('/ltjf/api/admin/community/park/list', {
      params: {
        status,
        community_id,
        page,
        per_page
      },
      paramsSerializer(params) {
        return Qs.stringify(params);
      }
    })
  },

  // 车场配置
  config(
    community_id,
    park_key,
    park_name
  ) {
    return Axios.post('/ltjf/api/admin/community/park/update', {
      community_id,
      park_key,
      park_name
    });
  },

  // 删除车场配置
  del(
    id
  ) {
    return Axios.delete(`/wybx/api/admin/repair_attendant/${id}`);
  },

  // 启用车场配置
  enable(
    community_id,
    park_key
  ) {
    return Axios.post('/ltjf/api/admin/community/park/open', {
      community_id,
      park_key
    });
  },

  // 禁用车场配置
  disable(
    community_id,
    park_key
  ) {
    return Axios.post('/ltjf/api/admin/community/park/close', {
      community_id,
      park_key
    });
  },

}